
import { defineComponent, ref, reactive, toRefs, inject, nextTick } from 'vue'

import { ElMessage } from 'element-plus'
import { operationManualApi } from '@/api/modules/operationManual'

export default defineComponent({
  name: 'operationManualAddOrEditDialog',
  setup (props, ctx) {
    // 获取refs
    const addOrEditFormRef = ref()

    // 接收父级的方法
    const updateList: any = inject('updateList')

    // 新增、编辑表单数据
    const addOrEditFormInit: any = () => {
      return {
        name: '',
        type: 1
      }
    }

    const data: any = reactive({
      projectId: null,
      addOrEditDialog: false,
      addOrEditType: 0, // 0新增,1编辑
      addOrEditTypeTitle: ['新增', '编辑'],
      addOrEditForm: addOrEditFormInit(),
      addOrEditRules: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }]
      },
      determineBtnLoading: false,

      // 对话框显示
      async showAddOrEdit (projectId: number, id: number) {
        data.addOrEditType = id ? 1 : 0
        data.projectId = projectId

        // 有id时赋值
        if (id) {
          const { res } = await operationManualApi.getInfo({ id })
          console.log('根据id获取详情', res)
          data.addOrEditForm = res
        }
        data.addOrEditDialog = true
      },

      // 对话框关闭
      addOrEditCancel () {
        // console.log('对话框关闭')
        addOrEditFormRef.value.resetFields()
        data.addOrEditForm = Object.assign({}, addOrEditFormInit())
      },

      // 确认
      addOrEditDetermine () {
        addOrEditFormRef.value.validate(async (valid: any) => {
          if (!valid) return

          data.addOrEditForm.project_id = data.projectId
          console.log('data.addOrEditForm', data.addOrEditForm)

          try {
            data.determineBtnLoading = true
            await operationManualApi.save(data.addOrEditForm)
            ElMessage.success(`${data.addOrEditTypeTitle[data.addOrEditType]}成功`)
            data.addOrEditDialog = false
            data.determineBtnLoading = false

            // 父级更新列表
            updateList('place')
          } catch (error) {
            data.determineBtnLoading = false
          }
        })
      }
    })

    return {
      ...toRefs(data),
      addOrEditFormRef
    }
  }
})
